export const FILE_TREE_DEFAULT_SIZE = 20;
export const SIDEBAR_COLLAPSED_SIZE = 2.5;
export const SIDEBAR_DEFAULT_SIZE = 18;
export const VISIBLE_DIRTY_FILES_COUNT = 3;
